import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from "@angular/router";
import { CmsConfig, ConfigModule } from "@spartacus/core";
import { GenericLinkModule, MediaModule } from "@spartacus/storefront";
import { CustomSiteLogoComponent } from './custom-site-logo.component';

@NgModule({
  declarations: [CustomSiteLogoComponent],
  imports: [
    CommonModule,
    RouterModule, GenericLinkModule, MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SiteLogoComponent: {
          component: CustomSiteLogoComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomSiteLogoModule { }
